import combinationStorage from '@/services/combination-storage';

export default class CombinationService {
  static getVariantImage (item) {
    return item.cover ? item.cover : item.mainVariant.cover;
  };

  static getVariantTitleText (title) {
    return title.replace(/\s*\/\s*/g, ' | ');
  };
}
